import { render, staticRenderFns } from "./GapStatus.vue?vue&type=template&id=58548f6a&scoped=true&"
import script from "./GapStatus.vue?vue&type=script&lang=ts&"
export * from "./GapStatus.vue?vue&type=script&lang=ts&"
import style0 from "./GapStatus.vue?vue&type=style&index=0&id=58548f6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58548f6a",
  null
  
)

export default component.exports